export default __webpack_public_path__ + "static/media/planeSign.a2f15dba.svg";